"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceError = void 0;
const effect_1 = require("effect");
class ServiceError extends effect_1.Data.TaggedError('@fixtuur/gavel-client/ConfigurationServiceError') {
}
exports.ServiceError = ServiceError;
